/* eslint-disable indent */
/* eslint-disable no-unused-vars */

const isObj = require('lodash.get');

export const getAllShield = (state) => isObj(state, 'shield', []);
export const getShieldById = (state) => isObj(state, 'shieldById', []);
export const getDeletedShield = (state) => isObj(state, 'deletedShield', []);
